import React from "react";
import styled from "styled-components";

import Colours from "../utils/colours";

export default function ContentPanels(props) {
  return (
    <S.PanelsContainer data-cy="content-panels">
      <S.GridContainer panelCount={props.children.length}>
        {props.children.map(getPanel)}
      </S.GridContainer>
    </S.PanelsContainer>
  );

  function getPanel(panel, index) {
    if (panel.props.src) {
      return (
        <S.Order order={index + 1} key={panel.props.src}>
          <S.ImageContainer isCircle={panel.props.isCircle}>
            {panel}
          </S.ImageContainer>
        </S.Order>
      );
    }

    return <S.Content colour={panel.props.colour}>{panel}</S.Content>;
  }
}

const S = {};

S.PanelsContainer = styled.div`
  margin: auto;
`;

S.GridContainer = styled.article`
  display: grid;
  margin: 0 auto;
  position: relative;
  grid-template-columns: 1fr;
  grid-template-rows: ${(props) => `repeat(${props.panelCount}, 1fr)`};

  @media (min-width: 820px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: ${(props) => `repeat(${props.panelCount / 2}, 1fr)`};
  }
`;

S.Order = styled.article`
  width: 100%;
  height: 100%;

  ${(props) => {
    return `
      :nth-child(${props.order}) {
        order: ${props.order};
      }
    `;
  }}

  @media (min-width: 820px) {
    ${(props) => {
      if (props.order % 4 === 3) {
        return `
          :nth-child(${props.order}) {
            order: ${props.order + 1};
          }
        `;
      }

      if (props.order % 4 === 0) {
        return `
          :nth-child(${props.order}) {
            order: ${props.order - 1};
          }
        `;
      }
    }}
  }
`;

S.ImageContainer = styled.div`
  position: relative;
  min-height: 400px;
  padding-top: 0;
  height: 100%;

  ${(p) =>
    p.isCircle &&
    `
    border-radius: 50%;
    overflow: hidden;
    aspect-ratio: 1/1;
    min-height: 300px;
    max-height: 300px;
    margin: auto;
    
    @supports not (aspect-ratio: 1/1) {
      padding-top: 300px;
      width: 300px;
      @media (min-width: 820px) {
        width 100%;
      }
    }
  `}

  @media (min-width: 820px) {
    height: 0;
    max-height: 500px;
    padding-top: 100%;
  }
`;

S.Content = styled.article`
  background-color: ${(p) => p.colour || Colours.white};
  height: 100%;
  width: 100%;
`;
